import Repository from './repository'

const resource = '/kpi'

export default {
  TrainingAverageTotalsGet (planId, weekId, type = null) {
    if(type == null) {
      return Repository.get(`${resource}/training-average-totals/${planId}/${weekId}`)
    }
    return Repository.get(`${resource}/training-average-totals/${planId}/${weekId}/${type}`)

  },
  CardioTotalsGet (planId, weekId) {
    return Repository.get(`${resource}/cardio-totals/${planId}/${weekId}`)
  },
  TrainingResumeGet (config = {}) {
    return Repository.get(`${resource}/total-trainings-resume`, config)
  },
    CaloricExpenditureByMonthGet(year, month) {
    return Repository.get(`${resource}/caloricExpenditure/${year}/${month}`)
  },
  CaloricExpenditureGet (trainingDate) {
    return Repository.get(`${resource}/caloricExpenditure/${trainingDate}`)
  },

}
